import { useState } from "react";
import "./CompetenciesBlock.css";

function CompetenciesBlock({ title, subtitle, competencies }) {
  const [selected, setSelected] = useState(null);

  return (
    <section className="block project-block">

      <div className="project-header">
        <h2 className="project-title">{title || ''}</h2>
        <p className="project-subtitle">{subtitle || ''}</p>
      </div>

      <div className="project-grid">
        {(competencies || []).map((item, index) => (
          <div
            key={index}
            className="project-card"
            onClick={() => setSelected(item)}
          >
            {item.image && <img src={item.image} alt={item.title || ''} />}
            <div className="project-label">{item.label || ''}</div>
            <div className="project-overlay">
              <span>Read Info</span>
            </div>
          </div>
        ))}
      </div>

      {selected && (
        <div className="project-details">
          <h2>{selected.title || ''}</h2>
          <h4>{selected.subtitle || ''}</h4>
          <p>{selected.description || ''}</p>
        </div>
      )}

    </section>
  );
}

export default CompetenciesBlock;
